import type { DevEventInboxFilter, DevEventInboxMessageDto } from '@/api';
import {
  type ColumnFilter,
  type FilterOption,
  toTimeRanges,
} from './price-row-filters';

/** Text columns with a multi-select filter; the options come from the loaded messages. */
export type EventInboxOptionColumn = 'topic' | 'type';

const toSelected = (value: unknown): string[] | undefined => {
  const selected = (value as string[] | undefined) ?? [];
  return selected.length > 0 ? selected : undefined;
};

/** Converts the material-react-table column filters of the event inbox table to the API filter. */
export const toEventInboxFilter = (
  columnFilters: readonly ColumnFilter[],
): DevEventInboxFilter => {
  const filter: DevEventInboxFilter = {};
  for (const { id, value } of columnFilters) {
    if (id === 'topic') {
      filter.topics = toSelected(value);
    } else if (id === 'type') {
      filter.types = toSelected(value);
    } else if (id === 'messageTime') {
      filter.messageTime = toTimeRanges(value);
    } else if (id === 'isProcessed') {
      const selected = toSelected(value);
      if (selected) filter.isProcessed = selected[0] === 'true';
    }
  }
  return filter;
};

/**
 * Filter options for a text column. Like the price rows, the options come from the newest messages and
 * the messages of the current filter, so the user can select values that the current filter hides.
 */
export const getEventInboxColumnOptions = (
  column: EventInboxOptionColumn,
  messageLists: readonly (readonly DevEventInboxMessageDto[])[],
): FilterOption[] => {
  const values = new Set<string>();
  for (const messages of messageLists) {
    for (const message of messages) {
      const value = message[column];
      if (value) values.add(value);
    }
  }
  return [...values].sort().map((id) => ({ id, label: id }));
};
